import React from "react";

import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
} from "../../_metronic/_partials/controls";
import { WixCategoriesTable } from "./wix-category-table/WixCategoriesTable";

export default function WixCategoriesCard() {
 
  return (
    <Card>
          <CardHeader title='Wix Categories'>
            <CardHeaderToolbar>
             
            </CardHeaderToolbar>
          </CardHeader>{" "}
      <CardBody>
        <WixCategoriesTable />
      </CardBody>
    </Card>
  );
}
